module.exports = __webpack_public_path__ + "media/images/mobile/solutions/1-796e919f30a637dea0274056e538c211.png";